import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import YamsCalculator from './components/YamsCalculator';
import GenericScoreSheet from './components/GenericScoreSheet';

function App() {
  return (
    <Router>
      <div className="App">
        <nav className="app-navbar">
          <Link to="/" className="nav-logo">Calculateurs de score de jeux de société</Link>
          <div className="nav-links">
            <Link to="/" className="nav-link">Accueil</Link>
            <Link to="/yams" className="nav-link">Yams</Link>
            <Link to="/generic" className="nav-link">Score générique</Link>
          </div>
        </nav>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/yams" element={<YamsCalculator />} />
          <Route path="/generic" element={<GenericScoreSheet />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
